<template>
  <div class="container">
    <div class="topInfo flex flexMiddle">
      <div class="avatarBox">
        <img :src="avatar" v-if="avatar">
        <img src="@/assets/images/avatar.png" v-else>
      </div>
    </div>
    <div class="cellBox bg-fff">
      <div class="cellItem flexCenter flexBetween line-b-E5E5E5">
        <label for="tel" class="requireSign">手机号：</label>
        <input type="text" id="tel" onkeyup="value=value.replace(/[^\d]/g,'')" v-model.trim="contentInfo.tel" placeholder="请输入手机号" class=" textright flex1">
      </div>
      <div class="cellItem flexCenter flexBetween line-b-E5E5E5">
        <input type="number" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="contentInfo.imgCode" placeholder="请输入图形验证码" class="flex1">
        <img :src="codeImg" @click="getImgCode()">
      </div>
      <div class="cellItem flexCenter flexBetween line-b-E5E5E5">
        <input type="number" oninput="value=value.replace(/[^\d]/g,'')" v-model.trim="contentInfo.noteCode" placeholder="请输入短信证码" class="flex1">
        <van-button size="small" type="primary" @click.stop="sendNoteCode">{{getText}}</van-button>
      </div>
    </div>
    <div class="footerBtn">
      <van-button :disabled="fetching" round block type="info" native-type="submit" @click="onSubmit">提交</van-button>
    </div>
  </div>
</template>
<script>
  import { Button,Toast,Dialog } from "vant";
  import { isCardNo,checkIDCard ,validatePhone,validateEmail} from '@/utils/validate'
  var InterValObj;
  export default {
  name: 'ChangePhone',
  components: {
   [Toast.name]:Toast,
   [Button.name]:Button,
   [Dialog.name]:Dialog
  },
  data() {
    return {
      contentInfo:{
        tel:'',
        noteCode:'',
        imgCode:'',
      },
      getText: '获取验证码',
      clock: false, //标记是否发送验证码
      isSubmit:true,//是否禁止触发‘提交’
      codeImg:'',
      fetching: false,
      avatar:''
    }
  },
  created() {
    this.GLOBAL.iosInputHandle();
    if(this.$route.params && this.$route.params.phone){
      this.contentInfo.tel = this.$route.params.phone;
    };
     if(this.$route.params && this.$route.params.avatar){
      this.avatar = this.$route.params.avatar;
    };
    this.getImgCode()
  },
  watch: {
    contentInfo:{
      handler(val,oldval){
        if(this.contentInfo.tel && this.contentInfo.tel.length > 11){
          this.contentInfo.tel = this.contentInfo.tel.substr(0, 11)
        };
        if(this.contentInfo.noteCode && this.contentInfo.noteCode.length > 4){
          this.contentInfo.noteCode = this.contentInfo.noteCode.substr(0, 4)
        };
        if(this.contentInfo.imgCode && this.contentInfo.imgCode.length > 4){
          this.contentInfo.imgCode = this.contentInfo.imgCode.substr(0, 4)
        };
      },
      deep:true
    }
  },
  methods: {
    getOppenId(){
      let self = this;
      return new Promise(function(resolve,reject){
        $.ajax({
          url: self.GLOBAL.url+'/common/generateOpenId',
          type: 'get',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          data: {

          },
          success: (res) => {
            resolve(res)
          },
          error: (e) => {
            reject(e)
            console.log(e);
          }
        })
      })
    },
    getImgCode() {
      let t = new Date().getTime()
      this.codeImg = this.GLOBAL.url + "/verifyCode/getVerifyCode?t=" + t;
    },
    sendNoteCode(){
      let self = this;
      if(!self.contentInfo.tel){
        Toast('请输入手机号！');
        return false
      }else if(!validatePhone(self.contentInfo.tel)){
        Toast('手机号格式错误！');
        return false
      }else if(!self.contentInfo.imgCode){
        Toast('图形验证码不可为空！');
        return false;
      };
      if (self.getText != '获取验证码' && self.getText != '重新发送') {
        //定时器期数期间不能发送
        return;
      }
      var time = 60;
      $.ajax({
        url: this.GLOBAL.url + '/openIdInfo/sendVerificationCode',
        type: 'post',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
          tel:self.contentInfo.tel,
          code:self.contentInfo.imgCode
        },
        success: (res) => {
          if (res.code == 200) {
            if (self.clock == false) {
              self.clock = true;
              InterValObj = window.setInterval(function() {
                if (time == 0) {
                  window.clearInterval(InterValObj);
                  self.getText = "重新发送";
                  self.clock = false;
                } else {
                  time--;
                  self.getText = time + ' s';
                }
              }, 1000);
            } else {
              return;
            };
          } else {
            Toast(res.msg);
          }
        },
        error: (e) => {
          console.log(e);
        }
      })
    },
    onSubmit(){
      let self = this;
      if(!self.contentInfo.tel){
        Toast('请输入手机号！');
        return false
      }else if(!validatePhone(self.contentInfo.tel)){
        Toast('手机号格式错误！');
        return false;
      }else if(!self.contentInfo.imgCode){
        Toast('请输入图形验证码');
        return false;
      }else if(!self.contentInfo.noteCode){
        Toast('请输入短信证码');
        return false;
      };
      Dialog.confirm({
        title: '提示',
        message: '确定修改手机号？',
      }).then(() => {
        if (self.fetching == true) {
          return false;
        };
        self.fetching =  true;
        $.ajax({
          url: this.GLOBAL.url + '/openIdInfo/updateTel',
          type: 'post',
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          data: {
            tel:self.contentInfo.tel,
            code:self.contentInfo.noteCode
          },
          success: (res) => {
            if (res.code == 200) {
              Toast('提交成功');
              setTimeout(()=>{
                self.$router.go(-1);
              },1500);
            } else {
              Toast(res.msg);
            };
            self.fetching =  false;
          },
          error: (e) => {
            self.fetching =  false;
            console.log(e);
          }
        })
      }).catch(() => {
        self.$router.go(-1);
      });
    }
  },
  computed: {

  },
}</script>
<style type="text/css" scoped>
.container {
  width: 100%;
  height: 100%;
}

.topInfo {
  padding: 10px 0;
}

.avatarBox {
  display: table-cell;
  width: 2.133333rem;
  height: 2.133333rem;
  vertical-align: middle;
  border-radius: 1.066667rem;
  overflow: hidden;
}

.avatarBox img {
  display: inline-block;
  width: 100%;
  height: 100%;
}

.cellBox {
  padding-left: 0.4rem;
}

.cellItem {
  padding: 0.4rem 0.4rem 0.4rem 0;
}

.requireSign:before {
  content: "*";
  display: inline-block;
  margin-right: 0.133333rem;
  color: #ee0a24;
}

.footerBtn {
  margin-top: 1.333333rem;
}
</style>